<!-- 完成回访备注弹窗 -->
<template>
  <a-modal
    title="完成回访备注"
    v-model:visible="visible"
    :footer="null"
    :centered="true"
    :destroy-on-close="true"
    width="480px"
    wrap-class-name="complete_remarks_modal"
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
  >
    <div class="content">
      <a-spin class="loading-box" :spinning="loading">
        <div class="warning" v-if="noticesData?.content">
          <div>{{ noticesData.content }}</div>
          <div class="icon">
            <CloseOutlined @click="handleCloseNotices(noticesData.id)" style="font-size: 16px" />
          </div>
        </div>
        <div class="complete-remarks" ref="remarksRef">
          <div v-if="list.length" class="remark-list">
            <div v-for="(item, index) in list" :key="index" class="remark-item">
              <div class="remark-header">
                <span class="da-name">{{ item.daName }}</span>
                <span class="remark-at">{{ item.remarkAt }}</span>
              </div>
              <div class="remark-reason">{{ item.reason }}</div>
            </div>
          </div>
          <div v-else class="empty">暂无备注</div>
        </div>
      </a-spin>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, reactive, nextTick } from 'vue'
import {
  getCompleteRemarks,
  getNextFollowupNotices,
  closeNotices
} from '@/api/UserPool/activeRevisit'
import { message } from 'ant-design-vue'
import { CloseOutlined } from '@ant-design/icons-vue'

const visible = ref(false)
const loading = ref(false)
const defaultPaginationConfig = {
  pageNo: 1,
  pageSize: 20,
  hasNext: false
}
const paginationConfig = reactive({ ...defaultPaginationConfig })
const doctAndPatientInfo = reactive({
  ucPatientId: undefined,
  ucDoctorId: undefined
})
const remarksRef = ref(null)
const list = ref([])
const noticesData = ref({})
const bodyStyle = {
  background: '#fff',
  padding: '12px'
}
// 数据初始化
function Init() {
  Object.assign(paginationConfig, defaultPaginationConfig)
  list.value = []
}
async function open(params) {
  visible.value = true
  loading.value = true
  Init()
  doctAndPatientInfo.ucPatientId = params.ucPatientId || 0
  doctAndPatientInfo.ucDoctorId = params.ucDoctorId || 0
  getNotices()
  getData()
  addListener() //增加滚动监听
}
async function getData() {
  try {
    const payload = {
      ...doctAndPatientInfo,
      pageNo: paginationConfig.pageNo,
      pageSize: paginationConfig.pageSize
    }
    const data = await getCompleteRemarks(payload)
    const { currPage, hasNext = false } = data
    list.value = list.value.concat(data?.list || [])
    paginationConfig.pageNo = currPage + 1
    paginationConfig.hasNext = hasNext
  } catch (error) {
    list.value = []
  } finally {
    loading.value = false
  }
}

//查询下次回访冲突提示
function getNotices() {
  getNextFollowupNotices(doctAndPatientInfo)
    .then(res => {
      noticesData.value = res
    })
    .catch(() => {
      noticesData.value = {}
    })
}
// 增加监听滚动事件
function addListener() {
  nextTick(() => {
    remarksRef?.value?.addEventListener('scroll', handleScroll)
  })
}
function handleCancel() {
  remarksRef?.value?.removeEventListener('scroll', handleScroll)
  visible.value = false
}
// 监听页面滚动事件
function handleScroll({ target }) {
  const DOM = target
  const scrollHeight = DOM.scrollHeight, //滚动条的高度
    scrollTop = DOM.scrollTop, //滚动条在Y轴滚动过的高度
    clientHeight = DOM.clientHeight //浏览器的可视高度
  if (scrollHeight - scrollTop - clientHeight < 1 && paginationConfig.hasNext) {
    getData()
  }
}
// 关闭回访冲突提示
function handleCloseNotices(noticeId) {
  closeNotices({ noticeId }).then(() => {
    message.success('操作成功')
    getNotices()
  })
}
defineExpose({ open })
</script>

<style lang="scss" scoped>
.warning {
  border-radius: 4px;
  background: #fff7ee;
  color: #fc8a0f;
  font-family: 'PingFang SC';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .icon {
    margin-left: 8px;
    cursor: pointer;
  }
}
// 完成回访备注弹窗内容
.complete-remarks {
  max-height: 400px;
  overflow-y: auto;
  .remark-list {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 12px;
    .remark-item {
      border-radius: 8px;
      background-color: #f5f6f7;
      .remark-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px;
        border-bottom: 1px solid #e6e6e6;
        .da-name {
          color: #333;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
        .remark-at {
          color: #999;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .remark-reason {
        padding: 12px;
        color: #333;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        white-space: pre-wrap;
        word-break: break-all;
      }
    }
  }
  .empty {
    padding: 40px 0;
    text-align: center;
    font-size: 14px;
    color: #999;
  }
}
</style>
